export function searchFilterCategories(categories, searchTerm) {
  if (!Array.isArray(categories) || categories.length === 0) return [];

  const term = (searchTerm || "")
    .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  return categories.filter(
    (category) => !term || category.title?.toLowerCase().includes(term)
  );
}
